"use client";

import { m } from "framer-motion";
import type { ReactNode } from "react";
import { landingViewport, staggerContainer } from "@/lib/landing-motion";

type Props = {
    children: ReactNode;
    className?: string;
    mode?: "inView" | "enter";
};

export function LandingRevealGroup({ children, className, mode = "inView" }: Props) {
    return (
        <m.div
            variants={staggerContainer}
            initial="hidden"
            {...(mode === "enter"
                ? { animate: "visible" as const }
                : { whileInView: "visible" as const, viewport: landingViewport })}
            className={className}
        >
            {children}
        </m.div>
    );
}
